import Cookies from 'js-cookie';

export default {
  get(key) {
    return Cookies.get(key);
  },
  set(key, value, options = {}) {
    Cookies.set(key, value, options);
  },
  getJSON(key) {
    return Cookies.getJSON(key);
  },
  setJSON(key, value) {
    Cookies.setJSON(key, value);
  },
};
